export default {
  aigc_tools_title: "AI Cases&Tools",
  aigc_tools_search_placeholder: "Search for an application that interests you, or start chatting directly",
  aigc_tools_chat: "Chatting",
  aigc_tools_tool: "Tool",
  aigc_tools_example: "Example",
  aigc_tools_class: "Class",
  aigc_tools_scene: "Scene",
  aigc_tools_inner_info: "Only display internal content that can be directly used",
  aigc_tools_resource_upload: "Resource Upload",
  aigc_tools_app_details: "Application Details",
  aigc_tools_access_details: "Access Details",
  aigc_tools_contact_admin: "Contact administrator",
  aigc_tools_similar: "Similar recommendations",
  aigc_tools_contact: "Please contact @benzemazhu",
  aigc_tools_empty: "No data under current filter selections.",
  aigc_tools_tag_new: "NEW",
  aigc_tools_tag_internal: "Internally available",
  aigc_tools_delete_message: "Delete a resource?",
  aigc_tools_delete_des: "Are you sure to delete <b>{name}</b>？The delete operation is irrevocable,Please confirm the operation.",
};